import React, { useState } from "react";
import { Table, Select, Button, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import styles from "./StaffMaterialMgmt.module.css";
import { useNavigate } from "react-router-dom";
import { SubmitButton } from "../../../../components";
import HeaderComponent from "../../../../components/HeaderComponent/HeaderComponent";
import { Dropdown, Modal, SearchInput, TextComponent } from "../../../../components";


const { Option } = Select;
const categoryOpt = [
  {
    value: "Category",
    role: "Category",
    id: 1,
  },
  {
    value: "Packaging Materials",
    role: "Packaging Materials",
    id: 2,
  },
  {
    value: "Baking Tools",
    role: "Baking Tools",
    id: 3,
  },
  {
    value: "Hygiene Supplies",
    role: "Hygiene Supplies",
    id: 4,
  },
  {
    value: "Decorating & Toppings",
    role: "Decorating & Toppings",
    id: 3,
  },
]

const MaterialMgmt = () => {
  const navigate = useNavigate();
  const [filterModal, setFilterModal] = useState(false);
  const [category, setCategory] = useState({
    value: "Category",
    role: "Category",
    id: 1,
  });


  const columns = [

    {
      title: "Material Name",
      dataIndex: "MaterialName",
      key: "MaterialName",

    },
    {
      title: "Quantity",
      dataIndex: "Quantity",
      key: "Quantity",
    },
    {
      title: "Category",
      key: "Category",
      dataIndex: "Category",
    },
    {
      title: "",
      key: "action",
      dataIndex: "Button",
      render: (text, record) => record.Button,
    },
  ];

  const data = [
    {

      MaterialName: "Cardboard",
      Quantity: "2 lbs",
      Category: "Packaging Materials ",
      Action: "View",
      Button:
        <SubmitButton
          title={"View"}
          primary
          btnClass={styles.actionBtn}
          onClick={() => navigate("/StaffWarehouse/StaffMaterialMgmt")}
        />
    },
    {

      MaterialName: "Plastic Containers",
      Quantity: "36 oz",
      Category: "Baking Tools",
      Button: <SubmitButton
        title={"View"}
        primary
        btnClass={styles.actionBtn}
        onClick={() => navigate("/StaffWarehouse/StaffMaterialMgmt")}
      />
    },
    {
      MaterialName: "Paper Bags",
      Quantity: "3 lbs",
      Category: "Hygiene Supplies",
      Button: <SubmitButton
        title={"View"}
        primary
        btnClass={styles.actionBtn}
        onClick={() => navigate("/StaffWarehouse/StaffMaterialMgmt")}

      />
    },
    {
      MaterialName: "Food-Grade Wrapping Film ",
      Quantity: "4 g",
      Category: "Decorating & Toppings",
      Button: <SubmitButton
        title={"View"}
        primary
        btnClass={styles.actionBtn}
        onClick={() => navigate("/StaffWarehouse/StaffMaterialMgmt")}

      />
    },
    {
      MaterialName: "Cake Boards",
      Quantity: "36 oz",
      Category: "Packaging Materials ",
      Button: <SubmitButton
        title={"View"}
        primary
        btnClass={styles.actionBtn}
        onClick={() => navigate("/StaffWarehouse/StaffMaterialMgmt")}
      />
    },
    {
      MaterialName: "Cardboard Boxes",
      Quantity: "3 lbs",
      Category: "Hygiene Supplies",
      Button: <SubmitButton
        title={"View"}
        primary
        btnClass={styles.actionBtn}
        onClick={() => navigate("/StaffWarehouse/StaffMaterialMgmt")}
      />
    },
    {
      MaterialName: "Paper Bags",
      Quantity: "2 lbs",
      Category: "Decorating & Toppings",
      Button: <SubmitButton
        title={"View"}
        primary
        btnClass={styles.actionBtn}
        onClick={() => navigate("/StaffWarehouse/StaffMaterialMgmt")}
      />
    },
    {
      MaterialName: "Plastic Containers",
      Quantity: "4 g",
      Category: "Baking Tools",
      Button: <SubmitButton
        title={"View"}
        primary
        btnClass={styles.actionBtn}
        onClick={() => navigate("/StaffWarehouse/StaffMaterialMgmt")}
      />
    },
    {
      MaterialName: "Food-Grade Wrapping Film",
      Quantity: "3 lbs",
      Category: "Packaging Materials ",
      Button: <SubmitButton
        title={"View"}
        primary
        btnClass={styles.actionBtn}
        onClick={() => navigate("/StaffWarehouse/StaffMaterialMgmt")}
      />
    },
  ];

  return (
    <div className={styles.mainCont}>
      {/* Heading Section with Right Controls */}
      <HeaderComponent
        heading={"Material"}
        onSearch={(e) => console.log(e.target.value)}
        onSubmit={() => navigate("/Warehouse/MaterialMGMT/CreateNewMaterial")}
        showSubmitButton={false}
        rightControlsStyle={styles.rightControlsStyle}
        showFilterIcon={true}
        showSearch={true}
        onClickFilter={() => setFilterModal(true)}

      />

      {/* Table Section */}
      <div className={styles.subCont}>
        <div className={styles.TableDiv}>
          <Table
            scroll={{ x: true }}
            columns={columns}
            dataSource={data}
            pagination={false}
            rowKey="No"
          />
        </div>
      </div>

      {/* //////////////////// Filters ////////////////////// */}

      <Modal
        open={filterModal}
        onCancel={() => {
          setFilterModal(false);
        }}
        className={styles.modalCont}
        title={"Filters"}
        headingClass={styles.modalHeading}
        width={"400px"}
        // btnStyle={{ width: "200px", }}
        twoButton
        okBtnTitle={"Apply Filters(1)"}
        cancelBtnTitle={"Reset All"}
        onClickCancelButton={() => setFilterModal(false)}
        onClickOkButton={() => {
          setFilterModal(false)
        }}
      // onBtnPress={() => setLimitExceedsModal(false)}
      >
        <Dropdown
          // label={"Category"}
          // labelClass={styles.DropDownLabel}
          value={category}
          inputStyle={{
            backgroundColor: "#F7F8F9",
            border: "1.5px solid #E8ECF4",
          }}
          inputClass={styles.DropdownInput}
          style={{ color: "var(--black-color)" }}
          options={categoryOpt}
          onChange={(e) => setCategory(e)}
        />
      </Modal>
    </div>
  );
};

export default MaterialMgmt;
